/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Router from 'vue-router'
import RegisterProduct from './../components/RegisterProduct.vue'
import ReferAFriend from './../components/cards/ReferAFriend.vue'
import PostRegistration from './../components/PostRegistration'
import NotImplemented from './../components/NotImplemented'
import Home from './../components/Home.vue'
import RuxDetails from './../components/RuxDetails'
import Login from './../components/Login'
import RuxList from './../components/RuxList'
import MyProfile from './../components/MyProfile'
import NotARUX from './../components/NotARUX'
import PackingListTemplateList from './../components/PackingListTemplate/List'
import PackingListTemplateItem from './../components/PackingListTemplate/Item'
import PackingListTemplateCreate from './../components/PackingListTemplate/Create'
import PackingListTemplatePublic from './../components/PackingListTemplate/Public'
import { rux } from './../../lib/rux'
import store from './../store'

Vue.use(Router)
const routes = [
  {
    path: '/',
    name: 'Home',
    component: RuxList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/scan/:version/:serialNumber',
    name: 'Scan',
    meta: {
      requiresAuth: false
    },
    beforeEnter: async (to, from, next) => {
      // Set force pin everytime.
      store.dispatch('rux/setForcePinOnRegistration', true)
      await store.dispatch('rux/getAllRux')
      switch (to.params.version) {
        case 'v0':
          // Just allow register
          store.dispatch('rux/setForcePinOnRegistration', false)
          store.dispatch('rux/setSerialNumberForRegistration', to.params.serialNumber)
          checkExistsAndRedirect(next, to.params.serialNumber)

          break
        case 'v1': {
          // Validate Serial Number before registration
          store.dispatch('rux/setForcePinOnRegistration', false)
          store.dispatch('rux/checkEncryptedSerialNumberIsValid', to.params.serialNumber).then((result) => {
            checkExistsAndRedirect(next)
          }).catch(() => {
            next('/not-a-rux')
          })
          break
        }
        case 'v2':
          // Force Validation against pin and valid serial number. This is the default behavior so no need to update the store
          store.dispatch('rux/checkEncryptedSerialNumberIsValid', to.params.serialNumber).then((result) => {
            checkExistsAndRedirect(to, result.data.serialNumber)
          }).catch((err) => {
            console.log(err)
            next('/not-a-rux')
          })
          break
        default:
          // Don't allow enter if another version.
          next('/not-a-rux')
          break
      }
    }

  },
  {
    path: '/register/',
    name: 'Register',
    component: RegisterProduct,
    meta: {
      requiresAuth: true
    }

  },
  {
    path: '/referral/',
    name: 'Referral',
    component: ReferAFriend,
    meta: {
      requiresAuth: false
    }

  },
  {
    path: '/details/:serialNumber',
    name: 'Details',
    component: RuxDetails,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/post-registration/:serialNumber',
    name: 'PostRegistration',
    component: PostRegistration,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login/:redirect?',
    name: 'Login',
    component: Login
  },
  {
    path: '/list',
    name: 'List',
    component: RuxList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: MyProfile,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/packing-list/',
    name: 'PackingList',
    component: PackingListTemplateList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/packing-list/show/:name',
    name: 'PackingListTemplateItem',
    component: PackingListTemplateItem,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/packing-list/create',
    name: 'PackingListTemplateCreate',
    component: PackingListTemplateCreate,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/packing-list/public/:uid/:key',
    name: 'PackingListTemplatePublic',
    component: PackingListTemplatePublic
  },
  {
    path: '/not-implemented',
    name: 'NotImplemented',
    component: NotImplemented
  }, {
    path: '/not-a-rux',
    name: 'NotARUX',
    component: NotARUX
  }
]
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes
})
router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  if (requiresAuth && !rux.isAuth()) { // TODO: Need to use store here not a direct reference to Rux.
    if (to.params.serialNumber || to.params.serialNumberHash) {
      router.push({ name: 'Login', params: { redirect: to.fullPath } })
    } else {
      router.push({ name: 'Login' })
    }
  } else {
    next()
  }
})
export default router
export { routes }

const goToRegister = () => {
  router.push({
    name: 'Register',
    query: {
      fromScan: true
    }
  })
}
const goToDetails = (serialNumber) => {
// Send to the product details page instead
  router.push({
    name: 'Details',
    params: {
      serialNumber
    },
    query: {
      fromScan: true
    }
  })
}
const goToReferAFriend = (referralLink) => {
  // Send to the referral page instead
    router.push({
      name: 'Referral',
      params: {
        referralLink
      },
      query: {
        fromScan: true
      }
    })
  }
const checkIsValid = async (serialNumber) => {
  return rux.validateSerialNumber(serialNumber)
}
const checkExistsAndRedirect = async (to, serialNumber) => {
  try {
    const email = await rux.checkRuxRegisteredToEmail(serialNumber)

    if (!email && !rux.isAuth()) {
      router.push({ name: 'Login', params: { redirect: to.fullPath } })
      return
    }

    if (email) {
      const referralLink = await store.dispatch('rux/checkReferralLink', serialNumber)
      if (referralLink && !rux.isAuth()) {
          goToReferAFriend(referralLink)
          return
      }
    }

    if (store.getters['rux/getRuxDetails'](serialNumber)) {
      goToDetails(serialNumber)
    } else {
      goToRegister(serialNumber)
    }
  } catch (error) {
    console.error(error)
    goToRegister(serialNumber)
  }
}